
import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const pastelColors = [
    // Azules
    '#4fa3f7',  // Azul pastel saturado
    '#a8e6f8',  // Azul cielo lavado saturado
    '#8bcaf2',  // Celeste medio
    '#b2e9ff',  // Hielo azul brillante

    // Turquesas y Aqua
    '#6ee0d7',  // Turquesa pastel viva
    '#63cfd1',  // Aqua más definido
    '#7ee0d0',  // Verde agua más vibrante
    '#94eee3',  // Verde lago más claro

    // Verdes
    '#43cc94',  // Verde pastel saturado
    '#88e3c3',  // Menta más viva
    '#7beab1',  // Menta fresca brillante
    '#a4f2d6',  // Verde hielo vibrante

    // Amarillos y Cremas
    '#ffd93b',  // Amarillo más vivo
    '#ffe4a8',  // Cremita más cálido
    '#ffe37d',  // Vainilla fuerte
    '#fff0b3',  // Beige mantequilla saturado

    // Naranjas
    '#ffa447',  // Naranja pastel vivo
    '#ffcba4',  // Durazno más cálido
    '#ffc285',  // Naranja claro intenso
    '#ffe2c4',  // Naranja nube suave

    // Rojos y Corales
    '#ff6b6b',  // Rojo pastel intenso
    '#ce7e7e',  // Coral más fuerte

    // Rosas
    '#f88fb3',  // Rosa pastel con punch
    '#e879d9',  // Rosado brillante y fuerte

    // Morados y Lavandas
    '#c37fff',  // Morado pastel vivo
    '#b3baf5',  // Lavanda más rica
];

function CreateTagModal({ show, onHide, onCreate }) {

    const [labelName, setLabelName] = useState('');
    const [selectedColor, setSelectedColor] = useState('');

    useEffect(() => {
        if (!show) {
            setLabelName('');
            setSelectedColor('');
        }
    }, [show]);

    const handleCreate = () => {
        if (labelName.trim() && selectedColor) {
            onCreate(labelName.trim(), selectedColor);
            onHide(); // cerrar modal después
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: '1rem' }}>Create New Label</Modal.Title>

            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontSize: '0.85rem', fontWeight: 500 }}>
                            Label Name
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter label name"
                            value={labelName}
                            onChange={(e) => setLabelName(e.target.value)}
                            style={{ fontSize: '0.9rem', padding: '0.5rem 0.75rem' }}
                        />
                    </Form.Group>

                    <Form.Group>
                        <Form.Label style={{ fontSize: '0.85rem', fontWeight: 500 }}>
                            Choose Label Color
                        </Form.Label>
                        
                        {/* Selector de color personalizado */}
                        <div className="mb-3">
                            <Form.Label style={{ fontSize: '0.8rem', color: '#666', marginBottom: '8px' }}>
                                Custom Color
                            </Form.Label>
                            <div className="d-flex align-items-center gap-2">
                                <input
                                    type="color"
                                    value={selectedColor}
                                    onChange={(e) => setSelectedColor(e.target.value)}
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        backgroundColor: 'transparent'
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder="#000000"
                                    value={selectedColor}
                                    onChange={(e) => setSelectedColor(e.target.value)}
                                    style={{
                                        flex: 1,
                                        padding: '8px 12px',
                                        border: '1px solid #ccc',
                                        borderRadius: '6px',
                                        fontSize: '0.85rem',
                                        fontFamily: 'monospace'
                                    }}
                                />
                            </div>
                        </div>

                        {/* Colores predefinidos */}
                        <div>
                            <Form.Label style={{ fontSize: '0.8rem', color: '#666', marginBottom: '8px' }}>
                                Preset Colors
                            </Form.Label>
                            <div className="d-flex flex-wrap gap-2">
                                {pastelColors.map((color) => (
                                    <div
                                        key={color}
                                        onClick={() => setSelectedColor(color)}
                                        style={{
                                            width: '28px',
                                            height: '28px',
                                            borderRadius: '6px',
                                            backgroundColor: color,
                                            border:
                                                selectedColor === color
                                                    ? '2px solid #222'
                                                    : '1px solid #ccc',
                                            boxShadow:
                                                selectedColor === color
                                                    ? '0 0 0 2px rgba(0,0,0,0.1)'
                                                    : 'none',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s',
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
                    </Form.Group>

                    {labelName && selectedColor && (
                        <div className="mt-4">
                            <Form.Label style={{ fontSize: '0.85rem', fontWeight: 500, display: 'block' }}>
                                Preview
                            </Form.Label>
                            <div
                                style={{
                                    backgroundColor: selectedColor,
                                    color: 'white',
                                    display: 'inline-block',
                                    borderRadius: '16px',
                                    padding: '4px 12px',
                                    fontSize: '0.8rem',
                                    fontWeight: 500,
                                    marginTop: '4px',
                                }}
                            >
                                {labelName}
                            </div>
                        </div>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
                <Button variant="primary"
                    disabled={!labelName || !selectedColor}
                    onClick={handleCreate}>
                    Create Label
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CreateTagModal;